import './sellerBox.scss';
import { FC } from 'react';
import { Button } from 'tedooo-web-design-system/ui';
import { Message, UserCheck, UserPlus } from 'tedooo-web-design-system/icons';

import { Avatar } from 'components/avatar/Avatar';
import { translations } from 'translations/en';
import { ISellerBox } from 'types';

const SellerBox: FC<ISellerBox> = ({
  avatar,
  title,
  name,
  shopName,
  onUserClick,
  isFollowing,
  onMessageSellerClick,
  onFollowingClick,
}) => {
  const prefixIcon = isFollowing ? <UserCheck /> : <UserPlus />;

  const buttonText = isFollowing ? translations.COMMON.FOLLOWING : translations.COMMON.FOLLOW;

  return (
    <div className="seller-box-container">
      <span className="title">{title}</span>
      <div className="seller-info">
        <Avatar src={avatar} size={40} />
        <div className="description">
          <span className="name" onClick={onUserClick}>
            {name}
          </span>
          <span className="shop-name">{`Owner of ${shopName}`}</span>
        </div>
      </div>
      <div className="buttons-section">
        <Button
          type="secondary"
          size="small"
          borderRadius="small"
          prefixIcon={prefixIcon}
          isFullWidth
          text={buttonText}
          onClick={onFollowingClick}
        />
        <Button
          type="secondary"
          size="small"
          isFullWidth
          borderRadius="small"
          prefixIcon={<Message />}
          text={translations.COMMON.MESSAGE_SELLER}
          onClick={onMessageSellerClick}
        />
      </div>
    </div>
  );
};

export default SellerBox;
